module.exports = __webpack_public_path__ + "img/icons8-security-shield.8be4932e.svg";